import React from 'react';
import {isNative} from '../utils/utils';

import Browser from '../components/Browser';
import Phone from '../components/Phone';

const Preview = ({children}) => {
  if (isNative()) {
    return <Phone>{children}</Phone>;
  }
  return <Browser> {children} </Browser>;
};

export default Preview;



// WEBPACK FOOTER //
// ./src/components/Preview.js